import React from 'react'

const SelectIcon = () => {
    return (
        //         <svg className='select-icon' data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 279.54 250.7">
        //             <defs>
        //                 <style>
        //                     {`
        //     .cls-1si {
        //       fill: none;
        //       stroke-linecap: round;
        //       stroke-linejoin: round;
        //       stroke-width: 30px;
        //     }
        //   `}
        //                 </style>
        //             </defs>
        //             <polyline className="cls-1si" points="196.79 15 15 15 15 235.7 239.05 235.7 239.05 116.96" />
        //             <polyline className="cls-1si" points="59.27 91.47 127.02 159.22 264.54 24.39" />
        //         </svg>



        <svg className='select-icon' data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 533.34 533.33">
            <defs>
                <style>
                    {
                        `
                    .sel-cls-1 {
                        fill: none;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                    stroke-width: 46px;
                    }
                        `
                    }

                </style>
            </defs>
            <polyline className='sel-cls-1' points="366.67 200 233.33 333.33 166.67 266.67" />
            <path className='sel-cls-1' d="M33.33,393.34v-253.33c0-37.34,0-56.02,7.27-70.28,6.39-12.54,16.58-22.74,29.13-29.13,14.26-7.27,32.94-7.27,70.28-7.27h253.33c37.34,0,56,0,70.26,7.27,12.54,6.39,22.75,16.58,29.14,29.13,7.27,14.26,7.27,32.93,7.27,70.27v253.33c0,37.34,0,56.01-7.27,70.27-6.39,12.54-16.6,22.76-29.14,29.15-14.25,7.26-32.88,7.26-70.14,7.26h-253.56c-37.26,0-55.92,0-70.17-7.26-12.54-6.39-22.74-16.6-29.13-29.14-7.27-14.26-7.27-32.92-7.27-70.26Z" />
        </svg>
    )
}

export default SelectIcon
